import { CircularProgress } from '@mui/material';
import { StyledContainer } from './styled';

const CircularLoading = () => (
  <StyledContainer id="featured-genres">
    <CircularProgress size="4rem" />
  </StyledContainer>
);

export default CircularLoading;
